import {ExploreGroup, TrainerFooterGroup, ManageGroup, TeachGroup} from '../groups';
import {HomeLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const TrainerMenu = (context: NavigationContext) => [
    HomeLink(context),
    TeachGroup(context),
    ManageGroup(context),
    ExploreGroup(context),
    TrainerFooterGroup(context)
];